import {
  Selectors,
  useWidgetState,
} from '@eCommerce/frontend-legacy-shared-library';

import PRHeader from 'components/PasswordReset/PRHeader';

export interface ConnectedPRHeaderProps {
  testID: string;
}

const ConnectedPRHeader: React.FC<ConnectedPRHeaderProps> = (props) => {
  const {testID} = props;
  const isLoggedIn = useWidgetState(Selectors.isLoggedInSelector) as boolean;

  return <PRHeader testID={testID} isLoggedIn={isLoggedIn} />;
};

export default ConnectedPRHeader;
